// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.14-13160(d472319fc5)-C19/08/2026-09:14:22-B19/08/2026-09:21:34' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.14-13160(d472319fc5)-C19/08/2026-09:14:22-B19/08/2026-09:21:34",
  branch: "production",
  latestTag: "8.0.14",
  revCount: "13160",
  shortHash: "d472319fc5",
  longHash: "d472319fc5cd6fb7d6d736c23931f5626d5e38c2",
  dateCommit: "19/08/2026-09:14:22",
  dateBuild: "19/08/2026-09:21:34",
  buildType: "Ansible",
  } ;
